export default __webpack_public_path__ + "static/media/ConfigureWebhookInNeto(3).865429b2.png";